import {
  AUTH_BUTTON_CLASSES,
  AuthCard,
  AuthLayout,
  Div,
  LoaderButton,
  Typography,
  TypographyVariant,
} from '@up2rent/ui-new';
import isEmpty from 'lodash/isEmpty';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { setActiveOrganization, signOut, useActiveOrganization, useListOrganizations } from 'src/auth/client';
import { beginClientSwitch } from 'src/hooks/clientTransition';
import { invalidateAuthTokenCache } from 'src/hooks/UserContext';

import WorkspaceSwitchList from './WorkspaceSwitchList';

const AccessRevoked = () => {
  const { formatMessage } = useIntl();
  const [signingOut, setSigningOut] = useState<boolean>(false);
  const [switchingId, setSwitchingId] = useState<string | null>(null);

  const { data: activeOrganization } = useActiveOrganization();
  const { data: organizations } = useListOrganizations();
  const otherOrganizations = (organizations ?? []).filter((organization) => organization.id !== activeOrganization?.id);

  const handleSignOut = async () => {
    setSigningOut(true);
    try {
      await signOut();
    } finally {
      window.location.replace('/');
    }
  };

  const handleSwitch = async (organizationId: string) => {
    setSwitchingId(organizationId);
    beginClientSwitch();
    try {
      await setActiveOrganization({ organizationId });
      invalidateAuthTokenCache();
    } finally {
      window.location.reload();
    }
  };

  return (
    <AuthLayout>
      <AuthCard title={formatMessage({ id: 'accessRevoked.title' })}>
        <Typography variant={TypographyVariant.MUTED} className="mb-5">
          {formatMessage({ id: 'accessRevoked.body' })}
        </Typography>
        {!isEmpty(otherOrganizations) && (
          <Div className="mb-5">
            <WorkspaceSwitchList
              title={formatMessage({ id: 'accessRevoked.otherClients' })}
              workspaces={otherOrganizations}
              switchLabel={formatMessage({ id: 'accessRevoked.switchTo' })}
              switchingId={switchingId}
              disabled={switchingId !== null || signingOut}
              onSwitch={handleSwitch}
            />
          </Div>
        )}
        <LoaderButton className={AUTH_BUTTON_CLASSES} loading={signingOut} onClick={handleSignOut}>
          {formatMessage({ id: 'accountMenu.logout' })}
        </LoaderButton>
      </AuthCard>
    </AuthLayout>
  );
};

export default AccessRevoked;
